var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('van-loading',{attrs:{"color":"#0094ff","vertical":""}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }